module.exports = __webpack_public_path__ + "img/ACOMPAÑARE.b615624b.png";